export enum StatusAccount {
    INACTIVE = 'inactive',
    ACTIVE = 'active',
    DELETED = 'deleted',
    PAUSE = 'pause',
    STOPPED = 'stopped',
  }


